import { filter, slice, table } from 'smart-table-core';

export class Controller {

    /** @ngInject */
    constructor($scope) {
        this.$scope = $scope;
    }

    get pageSize() {
        return this.st.slice.state().size;
    }

    set pageSize(value) {
        value && this.st.slice.changePageSize(value);
    }

    get selectedPage() {
        return this.st.slice.state().page;
    }

    set selectedPage(value) {
        value && this.st.slice.selectPage(value);
    }

    $onInit() {
        this.searchText = '';
        this.initTable([]);
        this.loadItems();
    }

    initTable(items) {
        const data = items.filter(i => i.slug !== 'other');
        this.custom = items.find(i => i.slug === 'other');

        const st = this.st = {};

        st.table = table({data});

        st.filter = filter({table: st.table, pointer: 'serviceName'});
        st.slice = slice({table: st.table});
        st.slice.selectPage(1);
        st.slice.changePageSize(10);

        st.table.onDisplayChange(items =>
            this.$scope.$apply(() => {
                const {filteredCount, size} = st.slice.state();
                const values = items.map(i => i.value);
                this.pageCount = Math.ceil(filteredCount / size);
                this.displayedItems = [this.custom, ...values];
            })
        );
    }

    loadItems() {
        this.publicServicesWithEPM$.get()
            .then(items => this.initTable(items))
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-applications/supported-epm-types/list/supported-epm-types.controller.js